import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import InfiniteScroll from 'react-infinite-scroller';
import styles from './styles.scss';
import Loader from '../Loader3/Loader';

const cx = classNames.bind(styles);
export default function TableWrapper({
  className,
  columns,
  isLoading,
  children,
  infiniteScrollProps,
  emptyPlaceholder,
}) {
  function getBodyContent() {
    if (isLoading) {
      return (
        <tr className={cx('message')}>
          <td colSpan="12">
            <Loader />
          </td>
        </tr>
      );
    }
    if (emptyPlaceholder) {
      return (
        <tr className={cx('message')}>
          <td colSpan="12">{emptyPlaceholder}</td>
        </tr>
      );
    }

    return children;
  }

  return (
    <div className={cx('table-wrapper', className)}>
      <InfiniteScroll {...infiniteScrollProps} initialLoad={false} useWindow={false} element="table" threshold={400}>
        <thead>
          <tr className={cx('xsmall')}>
            {columns.map(
              ({
                label,
                hideMobile,
                hide,
                // eslint-disable-next-line no-shadow
                className,
              }) => !hide && (
                <th key={label.toLowerCase()} className={cx({ 'hide-mobile': hideMobile }, className)}>
                  {label}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>{getBodyContent()}</tbody>
      </InfiniteScroll>
    </div>
  );
}
TableWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  columns: PropTypes.array.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  infiniteScrollProps: PropTypes.object,
  emptyPlaceholder: PropTypes.string,
};
TableWrapper.defaultProps = {
  className: null,
  isLoading: false,
  infiniteScrollProps: {},
  emptyPlaceholder: null,
};
